<template>
  <div class="template"
       :class="setTheme">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TemplateDefault',
  computed: {
    ...mapGetters(['config']),
    setTheme() {
      return `theme-${this.config.theme}`;
    },
  },
  methods: {
    ...mapActions(['setModulesVisibility']),
  },
  mounted() {
    window.addEventListener('message', (event) => {
      const { action } = event.data;
      switch (action) {
        case 'openBoost':
          this.setModulesVisibility(true);
          break;
        case 'closeBoost':
          this.setModulesVisibility(false);
          break;
        default: break;
      }
    });
  },
  created() {
    this.setModulesVisibility(this.config.showOnLoad);
  },
};
</script>
